import ReactApexChart from 'react-apexcharts';
import { withNamespaces } from 'react-i18next';
import { Card, CardBody, CardTitle } from 'reactstrap';

import useSupplierOverviewTaskRiskOverview from '../../hooks/useSupplierOverviewTaskRiskOverview';

const normalizeColor = (color) => {
    if (!color) {
        return color;
    }

    return color.startsWith('#') ? color : `#${color}`;
};

const RiskLevelChartSkeleton = () => (
    <>
        <div className="dt-field dt-skeleton mb-2" style={{ width: '30%' }} />
        <div className="dt-field dt-skeleton" style={{ width: '90%', height: '320px' }} />
    </>
);

const RiskLevelChart = ({
    t,
    supplierId,
    isOwnCompany = false,
}) => {
    const fetchTaskRiskOverviewQuery = useSupplierOverviewTaskRiskOverview({
        supplierId,
        t,
    });

    if (fetchTaskRiskOverviewQuery.isLoading || fetchTaskRiskOverviewQuery.isFetching) {
        return <RiskLevelChartSkeleton />;
    }

    const items = fetchTaskRiskOverviewQuery.data?.riskLevel?.items || [];

    const chartOptions = {
        labels: [],
        plotOptions: {
            pie: {
                donut: {
                    size: '75%',
                },
            },
        },
        dataLabels: {
            enabled: true,
            dropShadow: false,
            formatter: (val, x) => {
                return x.w.config.series[x.seriesIndex];
            },
        },
        legend: {
            show: true,
            position: 'bottom',
        },
        colors: [],
    };

    const series = [];
    const labels = [];
    const colors = [];

    items.forEach((item) => {
        series.push(item.amount);
        labels.push(t(item.title));
        colors.push(normalizeColor(item.color));
    });

    const isSeriesEmpty = !series.length || series.every((s) => s === 0);

    return (
        <Card>
            <CardBody>
                <CardTitle className="overview-section-title mb-4">
                    {t(isOwnCompany ? 'Company Risk Level' : 'Third Party Risk Level')}
                </CardTitle>

                <ReactApexChart
                    options={{
                        ...chartOptions,
                        labels: isSeriesEmpty ? [t('No Data')] : labels,
                        colors: isSeriesEmpty ? ['e0e0e0'] : colors,
                    }}
                    series={isSeriesEmpty ? [1] : series}
                    type="donut"
                    height="350px"
                />
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(RiskLevelChart);
